import { Component, OnInit, OnDestroy } from "@angular/core";
import { BaMsgCenterService } from "./baMsgCenter.service";
import { TranslateService } from "@ngx-translate/core";
import { PqrService } from "../../../modules/employee/service/pqr/pqr.service";
import { RequisitionTaskService } from "../../../modules/employee/service/requisition-task/requisition-task.service";
import { RequisitionService } from "../../../modules/employee/service/requisition/requisition.service";
import { NotificationsService } from "../../services/notifications/notifications.service";
import { Pqr } from "../../../modules/employee/class/pqr";
import { Router } from "@angular/router";
import { HasPermissionService } from "../../../modules/employee/service/has-permission/has-permission.service";
import { WorkerCare } from "../../../modules/employee/class/worker-care";
import { WorkerCareService } from "../../../modules/employee/service/worker-care/worker-care.service";
import { RequisitionTask } from "../../../modules/employee/class/requisition-task";
import { Requisition } from "../../../modules/employee/class/requisition";
import { RadicationSSService } from "../../../modules/employee/service/radicationSS/radicationSS.service";
import { RadicationSS } from "../../../modules/employee/class/radicationSS";
import { GestionSACService } from "../../../modules/employee/service/gestionSAC/gestionSAC.service";
import { GestionSAC } from "../../../modules/employee/class/gestionSAC";
import { ProfileSurvey } from "../../../modules/employee/class/profile-survey";
import { ProfileSurveyService } from "../../../modules/employee/service/profile-survey/profile-survey.service";
import { ScheduleEmployeeService } from "../../../modules/employee/service/schedule-employee/scheduleEmployee.service";
import { ScheduleEmployee } from "../../../modules/employee/class/schedule-employee";
import { SystemRequestService } from "../../../modules/employee/service/system-request/system-request.service";
import { CandidateDisabilitiesService } from "../../../modules/disability/services/candidate-disabilities.service";

@Component({
  selector: "app-ba-msg-center",
  providers: [BaMsgCenterService],
  styleUrls: ["./baMsgCenter.scss"],
  templateUrl: "./baMsgCenter.html",
})
export class BaMsgCenterComponent implements OnInit, OnDestroy {
  public notifications: Array<Object> = [];
  public notifications2: Array<Object> = [];
  public notifications3: Array<Object> = [];
  public notifications4: Array<Object> = [];
  public notifications5: Array<Object> = [];
  public notifications6: Array<Object> = [];
  public notifications7: Array<Object> = [];
  public notifications8: Array<Object> = [];
  public notifications9: Array<any> = [];
  public messages: Array<Object>;

  public page: number = 1;
  public per_page: number = 100;
  public sort: string;
  public query: string;
  public pqrPosition: string;
  public filters: { key: string; value: string }[];
  public filters2: { key: string; value: string }[];
  public filters3: { key: string; value: string }[];
  public filters4: { key: string; value: string }[];
  public filters5: { key: string; value: string }[];
  public filters6: { key: string; value: string }[];
  public filters7: { key: string; value: string }[];
  public filters8: { key: string; value: string }[];
  public pqr: Pqr[];
  public requisitionTask: RequisitionTask[];
  public requisition: Requisition[];
  public workerCare: WorkerCare[];
  public radicationSS: RadicationSS[];
  public gestionSAC: GestionSAC[];
  public profileSurvey: ProfileSurvey[];
  public scheduleEmployee: ScheduleEmployee[];
  public documentsDisabilityPendingNotify: any[];
  public totalRecords: number = 0;
  public totalRecords2: number = 0;
  public totalRecords3: number = 0;
  public totalRecords4: number = 0;
  public totalRecords5: number = 0;
  public totalRecords6: number = 0;
  public totalRecords7: number = 0;
  public totalRecords8: number = 0;
  public totalRecords9: number = 0;
  public reloadInterval: any;
  public optionsSelectionTramite: any[];

  public myEmployeeId: string;
  public myRoleId: string;

  public requestData: any[];
  public notificationsSystems: Array<Object> = [];
  public totalRecordsSystems: number = 0;

  constructor(
    private _baMsgCenterService: BaMsgCenterService,
    public translate: TranslateService,
    public pqrService: PqrService,
    public requisitionTaskService: RequisitionTaskService,
    public requisitionService: RequisitionService,
    public workerCareService: WorkerCareService,
    public radicationSSService: RadicationSSService,
    public gestionSACService: GestionSACService,
    public scheduleEmployeeService: ScheduleEmployeeService,
    public profilesSurveyService: ProfileSurveyService,
    public candidateDisabilitiesService: CandidateDisabilitiesService,
    private notificationsService: NotificationsService,
    public router: Router,
    public hasPermissionService: HasPermissionService,
    public systemRequestService: SystemRequestService
  ) {
    this.messages = this._baMsgCenterService.getMessages();

    this.optionsSelectionTramite = [];
    this.optionsSelectionTramite.push({ label: "Inclusión EPS", value: "116" });
    this.optionsSelectionTramite.push({ label: "Traslado EPS", value: "117" });
    this.optionsSelectionTramite.push({ label: "Ausentismo", value: "115" });
    this.optionsSelectionTramite.push({ label: "Incapacidades", value: "118" });
    this.optionsSelectionTramite.push({ label: "Paz y Salvo", value: "13" });
    this.optionsSelectionTramite.push({
      label: "Afiliación Fonredes",
      value: "111",
    });
    this.optionsSelectionTramite.push({
      label: "Proceso Disciplinario",
      value: "73",
    });
    this.optionsSelectionTramite.push({
      label: "Solicitud devol aportes Fonredes",
      value: "112",
    });
    this.optionsSelectionTramite.push({
      label: "Solicitud prestamo Fonredes",
      value: "113",
    });
    this.optionsSelectionTramite.push({
      label: "Modificación de Cuota Fonredes",
      value: "114",
    });

    this.setfilter();
  }

  ngOnInit() {
    this.reloadInterval = setInterval(() => {
      this.setfilter();
    }, 300000);
  }

  playAudio() {
    let audio = new Audio();
    audio.src = "../../../../assets/audio/alert.mp3";
    audio.load();
    audio.play();
  }

  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    clearInterval(this.reloadInterval);
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public setfilter() {
    if (localStorage.getItem("profile")) {
      this.myEmployeeId = JSON.parse(
        localStorage.getItem("profile")
      ).employee_id;

      if (this.hasPermission("get pqrs notification")) {
        this.setFiltersPqr();
        this.getPqr();
      }

      if (this.hasPermission("get requisition task notification")) {
        this.setFiltersRequisitionTask();
        this.getRequisitionTask();
      }

      if (this.hasPermission("get requisition notification")) {
        this.setFiltersRequisition();
        this.getRequisition();
      }

      if (this.hasPermission("get radications notification")) {
        this.setFiltersRadication();
        this.getRadication();
      }

      if (this.hasPermission("get profile-surveis notification")) {
        this.setFiltersGetProfileSurvey();
        this.getProfileSurvey();
      }

      if (this.hasPermission("get gestionSAC notification")) {
        this.setFiltersGestionSAC();
        this.getGestionSAC();
      }

      if (this.hasPermission("get schedule-employee notification")) {
        this.setFiltersScheduleEmployee();
        this.getScheduleEmployee();
      }

      if (this.hasPermission("get systems requests notification"))
        this.getSystemsRequests("Abierto");

      if (
        this.hasPermission("get systems requests calification notification")
      ) {
        let created_by_id = JSON.parse(
          localStorage.getItem("profile")
        ).employee_id;
        this.getSystemsRequests("Cerrado", created_by_id);
      }

      if (this.myEmployeeId == "21638")
        // Notificaciones solo para Francico Gomez Incapacidades
        // existe un permiso llamado get disabilities documents notification por si se quiere usar en un futuro
        this.getDisabilitiesDocumentsPendingNotify();
    }
  }

  getPqr() {
    this.pqrService
      .getPqr(this.page, this.per_page, this.sort, this.query, this.filters)
      .toPromise()
      .then(
        (response) => {
          this.pqr = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords = response.json().meta.total_filtered;
          else this.totalRecords = response.json().meta.total;

          this.notifications = [];
          this.pqr.forEach((element) => {
            this.notifications.push({
              id: element.id,
              name: element.report_by,
              text: element.type_problem,
              time: element.created_at,
              img: "assets/img/app/profile/ik.png",
            });
          });

          if (this.notifications.length > 0) this.playAudio();
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  getRequisitionTask() {
    this.requisitionTaskService
      .getRequisitionTask(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters3
      )
      .toPromise()
      .then(
        (response) => {
          this.requisitionTask = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords3 = response.json().meta.total_filtered;
          else this.totalRecords3 = response.json().meta.total;

          this.notifications3 = [];
          this.requisitionTask.forEach((element) => {
            this.notifications3.push({
              id: element.id,
              created: element.created_by.name,
              task: element.task,
              status: element.status,
              time: element.created_at,
              img: "assets/img/app/profile/ik.png",
              requisition_id: element.requisition_id,
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  getRequisition() {
    this.requisitionService
      .getRequisition(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters4
      )
      .toPromise()
      .then(
        (response) => {
          this.requisition = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords4 = response.json().meta.total_filtered;
          else this.totalRecords4 = response.json().meta.total;

          this.notifications4 = [];
          this.requisition.forEach((element) => {
            this.notifications4.push({
              id: element.id,
              name: element.company.name,
              text: element.count,
              time: element.requested_at,
              img: "assets/img/app/profile/ik.png",
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  getWorkerCare() {
    this.workerCareService
      .getWorkerCare(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters2
      )
      .toPromise()
      .then(
        (response) => {
          this.pqr = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords2 = response.json().meta.total_filtered;
          else this.totalRecords2 = response.json().meta.total;

          this.notifications2 = [];
          this.pqr.forEach((element) => {
            this.notifications2.push({
              id: element.id,
              name: element.report_by,
              text: element.type_problem,
              time: element.created_at,
              img: "assets/img/app/profile/ik.png",
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  getRadication() {
    this.radicationSSService
      .getRadicationSS(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters5
      )
      .toPromise()
      .then(
        (response) => {
          this.radicationSS = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords5 = response.json().meta.total_filtered;
          else this.totalRecords5 = response.json().meta.total;

          this.changeLabelRadications();
          this.notifications5 = [];
          this.radicationSS.forEach((element) => {
            this.notifications5.push({
              id: element.id,
              name: element.received_by_id,
              text: element.labelTramite,
              time: element.created_at,
              img: "assets/img/app/profile/ik.png",
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  getGestionSAC() {
    this.gestionSACService
      .getGestionSAC(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters6
      )
      .toPromise()
      .then(
        (response) => {
          this.gestionSAC = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords6 = response.json().meta.total_filtered;
          else this.totalRecords6 = response.json().meta.total;

          this.notifications6 = [];
          this.gestionSAC.forEach((element) => {
            this.notifications6.push({
              id: element.id,
              name: element.management_made_client,
              text: element.company.name,
              time: element.created_at,
              img: "assets/img/app/profile/ik.png",
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              JSON.parse(error._body).errors.forEach((element) => {
                if (element.source) {
                  if (element.source.pointer) {
                    this.translate
                      .get(element.source.pointer)
                      .subscribe((res3: string) => {
                        msg = msg + res3 + ", ";
                      });
                  }
                }
              });
              this.notificationsService.growlNotify(
                "error",
                res1 + " " + ": " + msg
              );
            });
        }
      );
  }

  getProfileSurvey() {
    this.profilesSurveyService
      .getProfileSurvey(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters7
      )
      .toPromise()
      .then(
        (response) => {
          this.profileSurvey = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords7 = response.json().meta.total_filtered;
          else this.totalRecords7 = response.json().meta.total;

          this.notifications7 = [];
          this.profileSurvey.forEach((element) => {
            this.notifications7.push({
              id: element.id,
              name: element.changed_by.name,
              text: element.employee_position,
              time: element.updated_at,
              img: "assets/img/app/profile/ik.png",
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  getScheduleEmployee() {
    this.scheduleEmployeeService
      .getScheduleEmployee(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters8
      )
      .toPromise()
      .then(
        (response) => {
          this.scheduleEmployee = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords8 = response.json().meta.total_filtered;
          else this.totalRecords8 = response.json().meta.total;

          this.notifications8 = [];
          this.scheduleEmployee.forEach((element) => {
            this.notifications8.push({
              id: element.id,
              name: element.employee.name,
              text: element.location,
              time: element.startTime,
              img: "assets/img/app/profile/ik.png",
            });
          });
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  public getSystemsRequests(status, createdById?: number) {
    let filtersSystems = [];
    filtersSystems.push({ key: "status", value: status });

    if (createdById)
      filtersSystems.push({ key: "created_by_id", value: createdById });

    this.systemRequestService
      .getSystemsRequest(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        filtersSystems
      )
      .toPromise()
      .then(
        (response) => {
          this.requestData = response.json().data;

          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecordsSystems = response.json().meta.total_filtered;
          else this.totalRecordsSystems = response.json().meta.total;

          this.notificationsSystems = [];
          for (var i = 0; i < this.requestData.length; i++) {
            this.notificationsSystems.push({
              id: this.requestData[i].id,
              name: this.requestData[i].created_by.name,
              type: this.requestData[i].type_request.type,
              text: this.requestData[i].typification.description,
              time: this.requestData[i].date_request,
              img: "assets/img/app/profile/Luciana.png",
            });
          }
        },
        (error) => {
          let msgs;
          msgs = [];
          msgs.push({ severity: "error", summary: "error" });
        }
      );
  }
  public getDisabilitiesDocumentsPendingNotify() {
    this.candidateDisabilitiesService
      .getDocumentsDisabilityPendingNotify()
      .toPromise()
      .then(
        (response) => {
          this.documentsDisabilityPendingNotify = response.json().data;
          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords9 = response.json().meta.total_filtered;
          else this.totalRecords9 = response.json().meta.total;

          this.notifications9 = [];
          this.documentsDisabilityPendingNotify.forEach((element) => {
            this.notifications9.push({
              disability_id: element.disability_id,
              candidate_name: element.candidate_name.toLowerCase(),
              document_type: element.document_type,
              document_name: element.document_name,
              document_id: element.document_id,
              uploaded_at: element.uploaded_at,
            });
          });

          if (this.notifications9.length > 0) this.playAudio();
        },
        (error) => {
          let msg = "";
          this.translate
            .get(JSON.parse(error._body).errors[0].detail)
            .subscribe((res1: string) => {
              this.translate
                .get(JSON.parse(error._body).errors[1].detail)
                .subscribe((res2: string) => {
                  JSON.parse(error._body).errors.forEach((element) => {
                    if (element.source) {
                      if (element.source.pointer) {
                        this.translate
                          .get(element.source.pointer)
                          .subscribe((res3: string) => {
                            msg = msg + res3 + ", ";
                          });
                      }
                    }
                  });
                  this.notificationsService.growlNotify(
                    "error",
                    res1 + " " + res2 + ": " + msg
                  );
                });
            });
        }
      );
  }

  public gotoSchedule(id) {
    this.router.navigate(["/pages/schedule-employees"], {
      queryParams: { id_schedule_employee: id },
    });
  }

  public gotoProfileSurvey(id) {
    this.router.navigate(["/pages/profile-survey"], {
      queryParams: { profile_survey: id },
    });
  }

  public gotoGestionSAC(id) {
    this.router.navigate(["/pages/service-client/gestionSACs/" + id]);
  }

  public gotoPqr(id) {
    this.router.navigate(["/pages/pqrs/pqrs_asigned"], {
      queryParams: { id_pqr: id },
    });
  }

  public gotoRequisitionTask(id, requisition_id) {
    this.router.navigate(["/pages/selection/requisitions"], {
      queryParams: { id_requisition: requisition_id },
    });
  }

  public gotoRequisition(id) {
    this.router.navigate(["/pages/selection/requisitions/" + id]);
  }

  public gotoRadications(id) {
    this.router.navigate(["/pages/service-client/radications-ss"], {
      queryParams: { id_radicationSS: id },
    });
  }

  public goToSystemRequest(id) {
    this.router.navigate(["/pages/innovation/systems-requests/" + id]);
  }

  public gotoDisabilityAdmin(id_disibility) {
    this.router.navigate(["/pages/disabilities/" + id_disibility]);
  }

  public changeLabelRadications() {
    this.radicationSS.forEach((element) => {
      element.labelTramite = element.tramite;
      this.optionsSelectionTramite.forEach((element2) => {
        if (element.tramite.indexOf(element2.value) != -1) {
          element.labelTramite = element2.label;
        }
      });
    });
  }

  // Método para marcar un documento individual como visto
  public markDocumentAsViewed(documentId: number): void {
    this.candidateDisabilitiesService
      .markDocumentsAsViewed([documentId])
      .toPromise()
      .then(
        (response) => {
          // Remover el documento del array de notificaciones
          const index = this.notifications9.findIndex(
            (doc) => doc.document_id === documentId
          );
          if (index !== -1) {
            this.notifications9.splice(index, 1);
            // También actualizar el array original si es necesario
            const originalIndex =
              this.documentsDisabilityPendingNotify.findIndex(
                (doc) => doc.document_id === documentId
              );
            if (originalIndex !== -1) {
              this.documentsDisabilityPendingNotify.splice(originalIndex, 1);
            }
          }
          this.totalRecords9--;
        },
        (error) => {
          console.error("Error al marcar documento como visto:", error);
          this.notificationsService.growlNotify(
            "error",
            "Error al marcar el documento como visto"
          );
        }
      );
  }

  // Método para remover una notificación localmente (sin llamar al backend)
  public removeNotification(index: number): void {
    // Obtener el documento antes de eliminarlo para actualizar también el array original
    const documentId = this.notifications9[index].document_id;

    // Remover del array de notificaciones mostradas
    this.notifications9.splice(index, 1);
    this.totalRecords9--;

    // También remover del array original
    const originalIndex = this.documentsDisabilityPendingNotify.findIndex(
      (doc) => doc.document_id === documentId
    );
    if (originalIndex !== -1) {
      this.documentsDisabilityPendingNotify.splice(originalIndex, 1);
    }
  }

  // Método para marcar todas las notificaciones como vistas
  public markAllAsViewed(): void {
    // Obtener todos los IDs de documentos
    const documentIds = this.notifications9.map((doc) => doc.document_id);

    if (documentIds.length > 0) {
      this.candidateDisabilitiesService
        .markDocumentsAsViewed(documentIds)
        .toPromise()
        .then(
          (response) => {
            // Limpiar ambos arrays
            this.notifications9 = [];
            this.documentsDisabilityPendingNotify = [];
            this.totalRecords9 = 0;
          },
          (error) => {
            console.error(
              "Error al marcar todos los documentos como vistos:",
              error
            );
            this.notificationsService.growlNotify(
              "error",
              "Error al marcar los documentos como vistos"
            );
          }
        );
    }
  }

  public uniqueValues(input: string) {
    const venueArray = input.split(",");

    // Eliminar los elementos duplicados utilizando Set
    var uniqueVenueArray = venueArray.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    // Convertir el arreglo de nuevo a una cadena
    const uniqueVenue = uniqueVenueArray.join(",");
    return uniqueVenue;
  }

  public setFiltersPqr() {
    this.filters = [];
    var department = "";
    var venue = "";
    if (this.hasPermission("get pqr Sistemas")) {
      department += "1,42,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Gerencia")) {
      department += "2,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Comercial")) {
      department += "3,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Nómina")) {
      department += "4,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Suministros")) {
      department += "5,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Servicio al Cliente")) {
      department += "6,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr HSE")) {
      department += "7,";
    }
    if (this.hasPermission("get pqr Contratación")) {
      department += "8,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Contabilidad")) {
      department += "9,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Selección")) {
      department += "10,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Calidad")) {
      department += "11,";
    }
    if (this.hasPermission("get pqr Sercontratos")) {
      department += "12,";
      venue += "5,";
    }
    if (this.hasPermission("get pqr Gestión Humana")) {
      department += "13,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Gestión de Pagos")) {
      department += "14,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Medellín")) {
      venue += "4,";
    }
    if (this.hasPermission("get pqr Barranquilla")) {
      venue += "2,";
    }
    if (this.hasPermission("get pqr Cali")) {
      venue += "3,";
    }
    if (this.hasPermission("get pqr Bucaramanga")) {
      venue += "6,";
    }
    if (this.hasPermission("get pqr Buga")) {
      venue += "7,";
    }
    if (this.hasPermission("get pqr Jurídica")) {
      department += "25,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Seguridad Social")) {
      department += "45,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Facturacion")) {
      department += "46,";
    }

    if (this.hasPermission("get pqr Comunicaciones")) {
      department += "47,";
      venue += "1,";
    }
    if (this.hasPermission("get pqr Direccion Financiera")) {
      department += "48,";
      venue += "1,";
    }

    if (this.hasPermission("get pqr Innovacion")) {
      department += "49,";
      venue += "1,";
    }

    if (this.hasPermission("get pqr Synergo")) {
      department += "50,";
      venue += "1,";
    }
    if (department != "") {
      department = this.uniqueValues(department);
      this.filters.push({ key: "department_id-in", value: department });
    }
    if (venue != "") {
      venue = this.uniqueValues(venue);
      this.filters.push({ key: "venue_id-in", value: venue });
    }

    if (department == "" && venue == "") {
      this.filters.push({ key: "report_user_id-in", value: this.myEmployeeId });
    }
    this.filters.push({ key: "status-in", value: "Abierta,En Trámite" });
  }

  public setFiltersWorkerCare() {
    this.filters2 = [];
    if (this.hasPermission("get pqr Sistemas")) {
      this.filters2.push({ key: "department_id-lk", value: "1" });
      this.filters2.push({ key: "department_id-lk", value: "42" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Gerencia")) {
      this.filters2.push({ key: "department_id-lk", value: "2" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Comercial")) {
      this.filters2.push({ key: "department_id-lk", value: "3" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Nómina")) {
      this.filters2.push({ key: "department_id-lk", value: "4" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Suministros")) {
      this.filters2.push({ key: "department_id-lk", value: "5" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Servicio al Cliente")) {
      this.filters2.push({ key: "department_id-lk", value: "6" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr HSE")) {
      this.filters2.push({ key: "department_id-lk", value: "7" });
    } else if (this.hasPermission("get pqr Contratación")) {
      this.filters2.push({ key: "department_id-lk", value: "8" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Contabilidad")) {
      this.filters2.push({ key: "department_id-lk", value: "9" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Selección")) {
      this.filters2.push({ key: "department_id-lk", value: "10" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Calidad")) {
      this.filters2.push({ key: "department_id-lk", value: "11" });
    } else if (this.hasPermission("get pqr Sercontratos")) {
      this.filters2.push({ key: "department_id-lk", value: "12" });
      this.filters2.push({ key: "venue_id-lk", value: "5" });
    } else if (this.hasPermission("get pqr Gestión Humana")) {
      this.filters2.push({ key: "department_id-lk", value: "13" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Gestión de Pagos")) {
      this.filters2.push({ key: "department_id-lk", value: "14" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Medellín")) {
      this.filters2.push({ key: "venue_id-lk", value: "4" });
    } else if (this.hasPermission("get pqr Barranquilla")) {
      this.filters2.push({ key: "venue_id-lk", value: "2" });
    } else if (this.hasPermission("get pqr Cali")) {
      this.filters2.push({ key: "venue_id-lk", value: "3" });
    } else if (this.hasPermission("get pqr Bucaramanga")) {
      this.filters2.push({ key: "venue_id-lk", value: "6" });
    } else if (this.hasPermission("get pqr Buga")) {
      this.filters2.push({ key: "venue_id-lk", value: "7" });
    } else if (this.hasPermission("get pqr Jurídica")) {
      this.filters2.push({ key: "department_id-lk", value: "25" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get PQR Seguridad Social")) {
      this.filters2.push({ key: "department_id-lk", value: "45" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Synergo")) {
      this.filters2.push({ key: "department_id-lk", value: "50" });
      this.filters2.push({ key: "venue_id-lk", value: "1" });
    } else {
      this.filters2.push({
        key: "person_receiving_id-in",
        value: this.myEmployeeId,
      });
    }

    this.filters2.push({ key: "status-in", value: "Abierta" });
  }

  public setFiltersRequisitionTask() {
    this.filters3 = [];
    this.filters3.push({ key: "employee_id-in", value: this.myEmployeeId });
    this.filters3.push({ key: "status-in", value: "Abierta" });
  }

  public setFiltersRequisition() {
    this.filters4 = [];
    this.filters4.push({ key: "status-in", value: "Abierto" });
    if (this.hasPermission("assign employee to requisition")) {
      this.filters4.push({ key: "progress-in", value: "Creado" });
    } else {
      this.filters4.push({ key: "employee_id-in", value: this.myEmployeeId });
      this.filters4.push({ key: "progress-in", value: "Asignado" });
    }
  }

  public setFiltersRadication() {
    this.filters5 = [];
    if (this.hasPermission("get pqr Sistemas")) {
      this.filters5.push({ key: "department_id-lk", value: "1" });
      this.filters5.push({ key: "department_id-lk", value: "42" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Gerencia")) {
      this.filters5.push({ key: "department_id-lk", value: "2" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Comercial")) {
      this.filters5.push({ key: "department_id-lk", value: "3" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Nómina")) {
      this.filters5.push({ key: "department_id-lk", value: "4" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Suministros")) {
      this.filters5.push({ key: "department_id-lk", value: "5" });
    } else if (this.hasPermission("get pqr Servicio al Cliente")) {
      this.filters5.push({ key: "department_id-lk", value: "6" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr HSE")) {
      this.filters5.push({ key: "department_id-lk", value: "7" });
    } else if (this.hasPermission("get pqr Contratación")) {
      this.filters5.push({ key: "department_id-lk", value: "8" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Contabilidad")) {
      this.filters5.push({ key: "department_id-lk", value: "9" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Selección")) {
      this.filters5.push({ key: "department_id-lk", value: "10" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Calidad")) {
      this.filters5.push({ key: "department_id-lk", value: "11" });
    } else if (this.hasPermission("get pqr Sercontratos")) {
      this.filters5.push({ key: "department_id-lk", value: "12" });
      this.filters5.push({ key: "venue_id-lk", value: "5" });
    } else if (this.hasPermission("get pqr Gestión Humana")) {
      this.filters5.push({ key: "department_id-lk", value: "13" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Gestión de Pagos")) {
      this.filters5.push({ key: "department_id-lk", value: "14" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Medellín")) {
      this.filters5.push({ key: "venue_id-lk", value: "4" });
    } else if (this.hasPermission("get pqr Barranquilla")) {
      this.filters5.push({ key: "venue_id-lk", value: "2" });
    } else if (this.hasPermission("get pqr Cali")) {
      this.filters5.push({ key: "venue_id-lk", value: "3" });
    } else if (this.hasPermission("get pqr Bucaramanga")) {
      this.filters5.push({ key: "venue_id-lk", value: "6" });
    } else if (this.hasPermission("get pqr Buga")) {
      this.filters5.push({ key: "venue_id-lk", value: "7" });
    } else if (this.hasPermission("get pqr Jurídica")) {
      this.filters5.push({ key: "department_id-lk", value: "25" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Seguridad Social")) {
      this.filters5.push({ key: "department_id-lk", value: "45" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else if (this.hasPermission("get pqr Synergo")) {
      this.filters5.push({ key: "department_id-lk", value: "50" });
      this.filters5.push({ key: "venue_id-lk", value: "1" });
    } else {
      this.filters5.push({
        key: "report_user_id-in",
        value: this.myEmployeeId,
      });
    }
    this.filters5.push({ key: "transacted", value: "0" });
  }

  public setFiltersGetProfileSurvey() {
    this.filters7 = [];
    this.filters7.push({ key: "changed", value: "1" });
  }

  public setFiltersScheduleEmployee() {
    this.filters8 = [];
    this.filters8.push({ key: "processed", value: "0" });
  }
  public setFiltersGestionSAC() {
    this.filters6 = [];
    this.filters6.push({ key: "approved_by_client", value: "0" }); //false
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baMsgCenter/baMsgCenter.component.ts